<app-title-ayuda-component [title]="pageTitle"></app-title-ayuda-component>
<div class="container">
  <span>{{politicComonent()?.firstPolicySectionTitle}}</span>
  <p>
    {{ politicComonent()?.firstPolicySectionDescription }}     
  </p>

  <span>{{ politicComonent()?.secondPolicySectionTitle }}</span>
  <p>
    {{ politicComonent()?.secondPolicySectionDescription }}   
  </p>

  <span>{{ politicComonent()?.thirdPolicySectionTitle }}</span>
  <br />

  <p class="sin-espacio">
    {{ politicComonent()?.thirdPolicySectionDescription }}    
  </p>
  <ul class="sin-espacio">
    <li>
      El titular de esta web utiliza los datos personales obtenidos en los
      formularios de contacto para poder contestar a las preguntas o peticiones
      que le solicite el usuario.
    </li>
  </ul>
  <p class="sin-espacio">
    b) En relación con el uso de cookies: Datos de navegación anónima a través
    de las páginas web.
  </p>

  <ul class="sin-espacio">
    <li>
      El nombre de dominio del proveedor (ISP) que da acceso a la red. Por
      ejemplo, un usuario del proveedor XXX solo estará identificado con el
      dominio xxx.es. De esta manera, se pueden elaborar estadísticas sobre los
      países y servidores que visitan más a menudo la web.
    </li>
    <li>
      La fecha y hora de acceso a la web. Permite averiguar las horas de mayor
      afluencia, y hacer los ajustes precisos para evitar problemas de acceso.
    </li>
    <li>
      El número de visitantes diarios de cada sección. Permite conocer las áreas
      de mayor interés y aumentar y mejorar su contenido, con el fin de que los
      usuarios obtengan un resultado más satisfactorio.
    </li>
    <li>
      El tipo de dispositivo, sistema operativo y navegador utilizado. Permite
      conocer estadísticas sobre los dispositivos utilizados por los usuarios y
      ajustar el contenido a sus características técnicas, con el fin de que los
      usuarios obtengan un resultado más satisfactorio
    </li>
  </ul>
  <br />
  <span>{{ politicComonent()?.fourthPolicySectionTitle }}</span>
  <p>
    {{ politicComonent()?.fourthPolicySectionDescription }}
  </p>

  <span>{{ politicComonent()?.fifthPolicySectionTitle}}</span>
  <p>
    {{ politicComonent()?.fifthPolicySectionDescription }}
  </p>

  <p>
    Derecho de portabilidad: Siempre que el titular de esta web procese sus
    datos personales a través de medios automatizados en base a su
    consentimiento o a un acuerdo, usted tiene derecho a obtener una copia de
    sus datos en un formato estructurado, de uso común y lectura mecánica
    transferida a su nombre o a un tercero. En ella se incluirán únicamente los
    datos personales que usted nos haya facilitado.
  </p>

  <p>
    Derecho de rectificación: Usted tiene derecho a solicitar la rectificación
    de sus datos personales si son inexactos, incluyendo el derecho a completar
    datos que figuren incompletos.
  </p>

  <p class="sin-espacio">
    Derecho de supresión: Usted tiene derecho a obtener sin dilación indebida la
    supresión de cualquier dato personal suyo tratado por el titular de esta web
    en cualquier momento, excepto en las siguientes situaciones:
  </p>

  <ul class="sin-espacio">
    <li>
      Si la información es necesaria para la formulación, el ejercicio o la
      defensa de reclamaciones del titular de la web, del usuario o de terceros.
    </li>
    <li>
      Si la información ha sido solicitada por las autoridades competentes.
    </li>
    <li>
      Si se sospecha o está confirmado que ha utilizado incorrectamente los
      servicios de la web en los últimos cuatro años.
    </li>
  </ul>
  <p class="sin-espacio">
    Derecho de oposición al tratamiento de datos en base al interés
    legítimo: Usted tiene derecho a oponerse al tratamiento de sus datos
    personales en base al interés legítimo del titular de esta página web. El
    titular de esta web no seguirá tratando los datos personales a menos que
    podamos acreditar motivos legítimos imperiosos para el tratamiento que
    prevalezcan sobre sus intereses, derechos y libertades, o bien para la
    formulación, el ejercicio o la defensa de reclamaciones.
  </p>

  <p>
    Derecho a presentar una reclamación ante una autoridad de control: Si usted
    considera que el titular de esta web trata sus datos de un modo incorrecto,
    puede contactar con él dirigiéndose a la dirección de correo ordinario o
    electrónico del titular de la página web. También tiene derecho a presentar
    una queja ante la autoridad de protección de datos competente.
  </p>

  <p class="sin-espacio">
    Derecho a la limitación en el tratamiento: Usted tiene derecho a solicitar
    que el titular de esta web limite el tratamiento de sus datos personales en
    las siguientes circunstancias:
  </p>
  <ul class="sin-espacio">
    <li>
      Si usted se opone al tratamiento de sus datos en base al interés legítimo
      de del titular de esta web, éste deberá limitar cualquier tratamiento de
      dichos datos a la espera de la verificación del interés legítimo.
    </li>
    <li>
      Si usted reclama que sus datos personales son incorrectos, el titular de
      esta web debe limitar cualquier tratamiento de dichos datos hasta que se
      verifique la precisión de los mismos.
    </li>
    <li>
      Si el tratamiento es ilegal, usted podrá oponerse a que se eliminen los
      datos personales y, en su lugar, solicitar la limitación de su uso.
    </li>
    <li>
      Si el titular de esta web ya no necesita los datos personales, pero usted
      los necesita para la formulación, el ejercicio o la defensa de
      reclamaciones.
    </li>
  </ul>

  <p class="sin-espacio">
    Ejercicio de derechos: Para cuestiones relacionadas con el ejercicio de sus
    derechos o para cualquier otra información o aclaración al respecto, se
    dirija a la dirección de correo ordinario o electrónico del titular de la
    página web.
  </p>
</div>
